import angular from 'angular';
import 'angular-img-cropper';

import ThumbnailModalController from './modal.controller';
import ThumbnailsController from './controller';

angular.module('generator.thumbnails', [
  'ngFileUpload',
  'angular-img-cropper',
  'generator.creativePreview',
  'generator.shared'
]);

angular
  .module('generator.thumbnails')
  .controller('ThumbnailsController', ThumbnailsController)
  .controller('ThumbnailModalController', ThumbnailModalController);
